import {
  AirPopulationCardInfo,
  AirPopulationCardInfoApi,
  AirPopulationItemResult,
  AirPopulationResultApi,
} from 'interfaces/types/AirPopulation'

import { wrapFormatFn } from './utils'

export const formatAirPopulationDataResult = wrapFormatFn(
  (data?: AirPopulationResultApi | null): AirPopulationItemResult | null => {
    if (typeof data === 'undefined' || !data) return null
    return {
      province: data.state || '',
      keyCategory: data.key_category,
      category: data.category,
      description: data.description,
      qualityMin: data.air_quality_min || null,
      qualityMax: data.air_quality_max || null,
      currentAqiusValue: data?.pollution?.aqius || null,
      updatedTime: data?.pollution?.ts || null,
    }
  },
)

export const formatAirPopulationCardInfo = wrapFormatFn(
  (data?: AirPopulationCardInfoApi | null): AirPopulationCardInfo | null => {
    if (typeof data === 'undefined' || !data) return null
    return {
      title: data.title || '',
      description: data.description || '',
      disclaimer: data.disclaimer || '',
      featuredImage: data.featured_image || '',
    }
  },
)
